<template>
  <div class="finish">
    <div class="finish__dialog">
      <img class="finish__img" src="~assets/img/rocket-finish.svg" alt="">
      <h1 class="finish__title">You've finished</h1>
      <button @click="getResults" class="custom-btn custom-btn--green mb-2">
        <clip-loader :loading="processing" :color="'white'" :size="'17px'"></clip-loader>
        <span v-if="!processing">View results</span>
      </button>
      <div class="finish__org">
        <p class="my-0">Organomyx assessment complete</p>
        <dots-number activeDots='5'/>
      </div>
    </div>
  </div>
</template>

<script>
// API
import demoApi from '@/api/demo';
// Components
import DotsNumber from '@/components/Evaluation/Dots';

export default {
  components: { DotsNumber },
  data() {
    return {
      processing: false,
    };
  },
  computed: {
    allAnswers() {
      return [].concat(...this.$store.state.demoSubjectAnswers);
    },
  },
  methods: {
    getResults() {
      this.processing = true;
      demoApi.submit({ answers: this.allAnswers }).then((response) => {
        this.$store.commit('submitResults', response.data);
        this.processing = false;
        this.$router.push({ name: 'demoResults' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Demo/Finish.vue